import { REQUEST_TYPE } from "../../constant";
import { xFetch } from "../../helpers/xhrHelpers";
import { getTransactionsUrl } from "../../helpers/url/transactions";

export const DISPATCH_ACTION_TYPE = "DISPATCH_ACTION_TYPE";
export const FETCHING_ALL_TRANSACTIONS = "FETCHING_ALL_TRANSACTIONS";
export const FETCHING_ALL_TRANSACTIONS_COMPLETED =
    "FETCHING_ALL_TRANSACTIONS_COMPLETED";
export const FETCHING_ALL_TRANSACTIONS_COMPLETED_WITH_ERROR =
    "FETCHING_ALL_TRANSACTIONS_COMPLETED_WITH_ERROR";

export const fetchAllTransactions = data => {
    let response = {};
    const url = getTransactionsUrl();
    return async dispatch => {
        try {
            response = await xFetch({
                url: url,
                method: REQUEST_TYPE.GET
            });
            const { status, payload: { data } = {} } = response || {};
            if (status === true) {
                dispatch({
                    type: FETCHING_ALL_TRANSACTIONS_COMPLETED,
                    payload: data
                });
            } else if (status === false) {
                dispatch({
                    type: FETCHING_ALL_TRANSACTIONS_COMPLETED_WITH_ERROR
                });
            }
        } catch (error) {
            throw error;
        }
        return response;
    };
};

function setTransactions(state, data) {
    const { transactions } = data;
    if (transactions) {
        return { ...state, ...transactions };
    }
    return state;
}

export default (state = {}, action = {}) => {
    const { type, payload = {} } = action;
    switch (type) {
        default:
            return setTransactions(state, payload);
    }
};
